import { fabric } from 'fabric';

const shouldAdjustImageSize = (canvasObj, image) => {
    const canvasHeight = canvasObj.height;
    const canvasWidth = canvasObj.width;
    if (image.width * image.scaleX > canvasWidth! / 3 + 1) {
        return true;
    }

    return image.height * image.scaleY > canvasHeight! / 3 + 1;
};

export const getImageJsonObject = async (url, imageCanvas, canvasObject, itemId) => {
    const canvasHeight = canvasObject.height,
        canvasWidth = canvasObject.width;
    return new Promise((resolve, reject) => {
        try {
            fabric.Image.fromURL(imageCanvas, (image) => {
                if (image.width && image.height && canvasHeight && canvasWidth) {
                    if (shouldAdjustImageSize(canvasObject, image)) {
                        const scale =
                            (canvasHeight > canvasWidth ? canvasWidth / canvasHeight : canvasHeight / canvasWidth) / 3;
                        resolve({
                            itemId,
                            url,
                            imageCanvas,
                            left: canvasWidth / 2 - (image.width * scale) / 2,
                            top: canvasHeight / 2 - (image.height * scale) / 2,
                            angle: 0,
                            scaleX: scale,
                            scaleY: scale,
                            width: image.width,
                            height: image.height,
                        });
                    } else {
                        resolve({
                            itemId,
                            url,
                            imageCanvas,
                            left: window.innerWidth / 2,
                            top: (window.innerHeight - 100) / 2,
                            angle: 0,
                            scaleX: 1,
                            scaleY: 1,
                            width: image.width,
                            height: image.height,
                        });
                    }
                }
            });
        } catch (e) {
            reject(e);
        }
    });
};
